import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.finish');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-finish',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.finish/view.scss */
/* src/app/portal.kiosk.finish/view.scss: no such file or directory */`],
})
export class PortalKioskFinishComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    public correctCount: number = 0;
    public totalCount: number = 0;
    public title: string = "";
    public imagePath: string = "";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const quizResult = this.event.get("quiz") || [];

        this.totalCount = quizResult.length;
        this.correctCount = quizResult.filter(q => q.response === q.answer).length;

        if (this.correctCount < 3) {
            this.title = "유산 유망주";
            this.imagePath = "/assets/images/design/prospect.svg";
            this.comment = "좋아요! 유산의 세계에 첫발을 내디뎠어요.";
        } else {
            this.title = "유산 전문가";
            this.imagePath = "/assets/images/design/expert.svg";
            this.comment = "멋져요! 유산 전문가의 자질이 보이네요!";
        }

        await this.service.render();
    }
}

export default PortalKioskFinishComponent;